import Typography from '@mui/material/Typography';
import { useInboxTodos } from 'features/tasks';
import React from 'react';

import * as Styled from './inbox-count.style';

export const LoadingInboxCount: React.FC = () => <Styled.Container $loading />;

export const InboxCount: React.FC = () => {
  const tasks = useInboxTodos({ includeFilters: false });

  return !!tasks.length ? (
    <Styled.Container>
      <Typography variant="overline" component="span">
        {tasks.length}
      </Typography>
    </Styled.Container>
  ) : null;
};
